module.exports = "/static/assets/ba9d714c9d47b7bee049487dd4cacfef.png";